import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getEducationDetails } from 'modules/activityDetails/EducationDetails/api/educationDetailsService'
import { EducationDetailsState, ApiEducationDetailsResponse } from './types'

const initialState: EducationDetailsState = {
  educationDetailsData: {},
}

const educationDetailsSlice = createSlice({
  name: 'educationDetails',
  initialState,
  reducers: {
    educationDetailsLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiEducationDetailsResponse>>
    ) {
      state.educationDetailsData = action.payload
    },
    clearEducationDetails(state) {
      state.educationDetailsData = initialState.educationDetailsData
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { educationDetailsLoaded, clearEducationDetails } = educationDetailsSlice.actions

export { clearEducationDetails }
export default educationDetailsSlice.reducer

export const loadEducationDetailsData = (educationId: Guid, resultId?: Guid) => {
  return createApiAction({
    apiCalls: {
      educationDetails: () => getEducationDetails(educationId, resultId),
    },
    payloadAction: educationDetailsLoaded,
    getResultToKeep: state => state.educationDetails.educationDetailsData.result,
  })
}
